<div class="data-load-management">
  <div class="header-label">
    <h2>Data Load Management</h2>
  </div>

  <div *ngIf="errorMessage" class="api-error-banner">
    {{ errorMessage }}
  </div>

  <div class="table-loader" *ngIf="isLoading">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <div class="table-wrapper" [class.loading]="isLoading">

    <table mat-table [dataSource]="dataSource" matSort [matSortActive]="sortBy" [matSortDirection]="sortDir" class="full-width">
      <ng-container matColumnDef="authorizationNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Authorization Number</th>
        <td mat-cell *matCellDef="let row">
          {{ row.AuthorizationNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="ftpDirectoryName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>FTP Directory Name</th>
        <td mat-cell *matCellDef="let row">
          {{ row.FTPDirectoryName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="loadToleranceDays">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Load Tolerance Days</th>
        <td mat-cell *matCellDef="let row">
          {{ row.LoadToleranceDays ?? '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="autoProcessFiles">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Auto Process Files</th>
        <td mat-cell *matCellDef="let row">
          <mat-icon class="status-icon" [class.active]="row.AutoProcessFiles">
            {{ row.AutoProcessFiles ? 'check_circle' : 'cancel' }}
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="lastUpdated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated Date</th>
        <td mat-cell *matCellDef="let row">
          {{ row.LastUpdated | date: 'mediumDate' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastUpdatedBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated By</th>
        <td mat-cell *matCellDef="let row">
          {{ row.LastUpdatedBy }}
        </td>
      </ng-container>
      
      <ng-container matColumnDef="comment">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Comment</th>
        <td mat-cell *matCellDef="let row">
          {{ row.Comment || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="no-header"></th>
        <td mat-cell *matCellDef="let row" class="actions-cell">
          <button mat-icon-button (click)="openEditDialog(row)" [disabled]="isLoading" matTooltip="Edit" class="table-action-btn table-action-edit"
            [attr.aria-label]="'Edit ' + row.AuthorizationNumber">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div *ngIf="dataSource.data.length === 0" class="no-results-message">
      No file authorizations found
    </div>
  </div>

  <mat-paginator showFirstLastButtons [length]="totalCount" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]"
    (page)="onPageChange($event)">
  </mat-paginator>
</div>
